<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;background-color: white;height: 20vh;padding-top: 10vh;">
            <img style="margin-bottom: 4vh; height: 4vh; width: auto" :src="tenttwo.imageUrltwo" alt="">
            <div style="font-size: 2rem;">{{ isEnglish ? tenttwo.texttwoen:tenttwo.texttwo}}</div>
        </div>
        <div style="display: flex;flex-direction: column;align-items: flex-start;gap: 0vh;  padding-left: 20vw;margin-top: 4vh">
            <div style="font-size: 1.5rem; margin-bottom: 3vh;font-weight: bold;">{{ isEnglish ? tentthree.titleoneen:tentthree.titleone}}</div>
            <div style="width: 62vw; color: black; font-size: 1rem;line-height: 2;">{{isEnglish ? tentthree.contenten: tentthree.content}}</div>
                    <!-- 下移的下划线 -->
        </div>

        <div style="margin-top: 5vh; width: 13vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

        <div style=" display:flex;flex-direction: column; align-items: flex-start; padding-left: 17.5vw; margin-top: 5vh;gap: 0vh;">
            <div style="padding-left: 2.6vw; font-weight: bold;font-size: 1rem;">{{ isEnglish ? tenttfour.titleoneen:tenttfour.titleone}}</div>
            <ul style="margin-top: 3vh; margin-left:2.6vh"> 
                <li v-for="(item, index) in (isEnglish ? tenttfour.contenten : tenttfour.content)" :key="index" style="font-size: 1rem; margin-left: 1.4vw;line-height: 2;">
                 {{ item }}
            </li>
              
            </ul>
            <div style="margin-top:1vh;color: gray;font-size: 0.8rem;padding-left: 2.73vw;">{{ isEnglish ? tenttfour.remarkeren:tenttfour.remarker}}</div>
        </div>


        <div style="margin-top: 10vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>


       <div >

        <div
      style="height: 45vh; display: flex; justify-content: flex-start; gap: 5vw; padding-left: 26vw;"
    >
      <div
        v-for="(service, index) in services"
        :key="index"
        style="display: flex; flex-direction: column; align-items: center; padding-top: 10vh;"
      >
        <div>
          <img :src="service.imgSrc" alt="" style="width: 4vw" />
        </div>
        <div style="margin-top: 2vh; font-weight: bold;">{{ isEnglish ? service.titleen: service.title }}</div>
        <div
          style="width: 22vw; text-align: center; margin-top: 2vh; color: #222222; font-size: 1rem"
        >
        {{ isEnglish ? service.descriptionen: service.description }}
        </div>
      </div>
    </div>

        <div style=" padding-left: 20vw;">
            <div style="font-weight: bold; font-size: 1.5rem;"> {{ isEnglish ? zhoangyaoshuoming.titleen: zhoangyaoshuoming.title }}</div>
            <div style="margin-top: 3vh;">
                <ul style="">
                    <!-- 使用 v-for 循环来渲染列表 -->
                    <li
                    v-for="(item, index) in zhoangyaoshuoming.items"
                    :key="index"
                    style="font-size: 1rem; margin-bottom: 3vh; list-style-type: none;"
                    >
                    <div style="color: black;">{{ isEnglish ? item.titleen: item.title }}</div>
                    <div
                        style="width: 56vw; font-size: 1rem; color: #222222; line-height: 2;"
                        
                    >
                    {{ isEnglish ? item.descriptionen: item.description }}
                    </div>
                    </li>
                </ul>
            </div>
        </div>
       </div>

       <div style="margin-top: 10vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

       <!-- 用户表单提交 -->
       <div class="fomeillustrate" style="margin-top: 10vh;">
        <div class="title">{{ isEnglish ?fomeillustratecontent.titleen:fomeillustratecontent.title}}</div>
        <div class="form-container">
            <form class="custom-form" @submit.prevent="handleSubmit">
                   <!-- 姓名 -->
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.nameen:fomeillustratecontent.name}} 
                        (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <input type="text" id="name" v-model="fomeillustrate.name" :placeholder="isEnglish ?fomeillustratecontent.alertnameen:fomeillustratecontent.alertname">
                </div>
               
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.phoneen:fomeillustratecontent.phone}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <input type="text" id="phone" v-model="fomeillustrate.phone" :placeholder="isEnglish ?fomeillustratecontent.alertphoneen:fomeillustratecontent.alertphone">
                </div>
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.emailen:fomeillustratecontent.email}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <input type="text" id="email" v-model="fomeillustrate.email" :placeholder="isEnglish ?fomeillustratecontent.alertemailen:fomeillustratecontent.alertemail">
                </div>
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.addressen:fomeillustratecontent.address}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <input type="text" id="address" v-model="fomeillustrate.address" :placeholder="isEnglish ?fomeillustratecontent.alertaddressen:fomeillustratecontent.alertaddress">
                </div>
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.messageen:fomeillustratecontent.message}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <input type="text" id="address" v-model="fomeillustrate.message" :placeholder="isEnglish ?fomeillustratecontent.alertmessageen:fomeillustratecontent.alertmessage">
                </div>
                <!-- <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.messageen:fomeillustratecontent.message}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <textarea  id="message" v-model="fomeillustrate.message":placeholder="isEnglish ?fomeillustratecontent.alertmessageen:fomeillustratecontent.alertmessage"></textarea>
                </div> -->
                <div class="form-group">
                    <label for="name">{{ isEnglish ?fomeillustratecontent.imagessen:fomeillustratecontent.imagess}} (<span style="color: red">*</span>{{ isEnglish ? 'Required' : '必填' }})</label>
                    <!-- <input type="file" id="image" name="image" accept="image/*" required>  -->


                                     <el-upload 
                                     :action="uploadAction"
                                     list-type="picture-card"
                                      :on-success="handleSuccess" 
                                      :show-file-list="true" 
                                      :on-remove="handleRemove"
                                     multiple 
                                     :file-list="fileList">
                                     <i slot="default" class="el-icon-plus"></i>
                                        </el-upload>

                                        <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                        </el-dialog>
                </div>
               
                        <!-- 提交按钮 -->
                <div class="form-group">
                    <button type="submit" :disabled="isSubmitting" class="submit-btn">{{ isEnglish ?'submit':'点击发送'}}</button>
                </div>
            </form>
        </div>
    </div>


       <div style="margin-top: 10vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

       <div style="display: flex; justify-content: center;flex-direction: column;align-items: center; margin-top: 10vh;">
        <div style="width:59vw">
            <div style="font-weight: bold; margin-bottom: 1vh; font-size: 1.5rem">{{ isEnglish ? tentsix.titleen: tentsix.title }}</div>
            <div style="color: gray; font-size: 0.8rem">{{ isEnglish ? tentsix.contonten: tentsix.contont }}</div>
        </div>
        <div style="margin-top: 8vh;">
            <img style="width: 56vw;" :src=" isEnglish ? tentsix.imageUrlsixen: tentsix.imageUrlsix " alt="">
        </div>
    </div>


    <div style="margin-top: 10vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

    <div style="display: flex;justify-content: flex-start;flex-direction: column; padding-left: 20vw; margin-top: 10vh">
        <div style="margin-bottom: 3vh; font-weight: bold ;font-size: 1.5rem;">{{ isEnglish ? fqa.titlen: fqa.title }}</div>
        <div style="display: flex;justify-content: flex-start;flex-direction: column;">
                             <!-- 使用 v-for 循环渲染常见问题 -->
                            <div v-for="(item, index) in fqa.faqItems" :key="index">
                                <div style="font-size: 1rem; margin-bottom: 0.7vh;font-weight: bold"> {{ isEnglish ? item.questionen:item.question }}</div>
                                <div style="margin-bottom: 3vh; font-size: 1rem;color: #222222; width: 60vw; line-height: 2;"> {{ isEnglish ? item.answeren: item.answer }}</div>
                            </div>    
        </div>
    </div>

    <div style="margin-top: 10vh; width: 60vw; margin-left: 20vw; border-bottom: 1px solid gray;"></div>

    <div style="color: gray;font-size: 0.8rem; margin-left: 20vw;margin-top: 3vh;">{{ isEnglish ? fqa.contentenden: fqa.contentend }}</div>
        <Bottom style="margin-top: 13vh;"></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
 
    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),

           // 使用 computed 属性来拼接 URL
                    uploadAction() {
                    return `${apiUrls.baseUrl}/website/dev-api/common/upload`;
                    },
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [], 
                isSubmitting:false,


                fomeillustratecontent:{
                    title:'售后提交',
                    name: '姓名',
                    phone: '联系电话',
                    email: '邮箱',
                    address: '地址',
                    message: '售后原因',
                    imagess:'证据上传',

                    titleen:'Commercial Cooperation',
                    nameen: 'name',
                    phoneen: 'phone',
                    emailen: 'email',
                    addressen: 'address',
                    messageen: 'message',
                    imagess :'证据上传',

                    alertname: '请输入您的姓名',
                    alertcompany: '请输入您的公司名称',
                    alertphone: '请输入您的联系电话',
                    alertemail: '请输入您的邮箱',
                    alertaddress: '请输入您的地址',
                    alertmessage: '请输入您的售后原因',
                    imagessen :'upload',

                    alerttitleen:'Please enter your ttitle',
                    alertnameen: 'Please enter your name',
                    alertcompanyen: 'Please enter your company name',
                    alertphoneen: 'Please enter your phone number',
                    alertemailen: 'Please enter your email address',
                    alertaddressen: 'Please enter your address',
                    alertmessageen: 'Please enter your message content'
                },
                fomeillustrate:{
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    message: '',
                    imagess:''
                },

                tenttwo:{
                    imageUrltwo: require('../../assets/logotuteng.png'),
                    texttwo:'售后/保修',
                    texttwoen:'售后/保修(英文)',
                },
                tentthree:{
                    titleone:'退换货服务',
                    titleoneen:'退换货服务2',
                    content:'在PUKI谱祺官方平台(京东官方旗舰店、官网商城)购买的产品,自签收之日起,如配件齐全未拆封且无人为损坏,可享有七天无理由退货。 自签收之日起七天质量问题可退货,十五天内质量问题可换货。',
                    contenten:'退换货服务2',
                },
                tenttfour:{
                    titleone:'下列行为将无法享受退、换货服务:',
                    titleoneen:'下列行为将无法享受退、换货服务:2',
                   content:[
                    '无质量问题并影响商品的第二次销售',
                    '缺少购物时开具的发票和购物明细单',
                    '无商品购买记录',
                    '购买商品后超过7天退、换货期限',
                    '非PUKI谱祺合法销售渠道所购买的产品',
                    '已经拆开原封且无法还原如新或原包装盒/箱已损坏',
                   ],
                   contenten:[
                    '无质量问题并影响商品的第二次销售2',
                    '缺少购物时开具的发票和购物明细单2',
                    '无商品购2买记录2',
                    '购买商品后超过7天退、换货期限2',
                    '非PUKI谱祺合法销售渠道所购买的产品2',
                    '已经拆开原封且无法还原如新或原包装盒/箱已损坏2',
                   ],
                
                   remarker:'备注:执行无理由退/换货的商品,在快递退回仓储中心的过程中所产生的损坏/损失，PUKI谮祺将有权不予手里退/换货,请顾客自行联络快递公司索赔。',
                   remarkeren:'备注:执行无理由退/换货的商品,在快递退回wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww赔。',
                },

                 // 定义一个包含多个服务信息的数组
                    services: [
                        {
                        imgSrc: require('../../assets/pic-service1.png'),
                        title: '三年免费保修服务',
                        titleen: '三年免费sss保修服务',
                        description:
                            '用户自购买产品之日起,在产品无偿保修范围内, 可享受长达三年的免费维修服务。',
                        descriptionen:
                            '用户自购买产品之日起,在产品无偿保修范围内, 可享受长达三年sssssss的免费维修服务。',
                        },
                        {
                        imgSrc: require('../../assets/pic-service2.png'),
                        title: '终身原厂保修服务',
                        titleen: '三年免费保修ssss服务',
                        description:
                            '用户在获得三年无偿保修服务之后,我们将在产品生命周期内，提供有偿的原厂保修服务。',
                        descriptionen:
                            '用户自购买产品之日起,在产品无偿保修范围内, 可享受长达三年sssssss的免费维修服务。',
                        },
                        
                    ],
                    zhoangyaoshuoming:{
                            title:'重要说明:',
                            titleen:'重要说明sss',
                             // 定义一个包含每个项目标题和内容的数组
                            items: [
                                {
                                title: '产品无偿保修范围:',
                                titleen: 'ssss:',
                                description:
                                    '由于产品生产材料缺陷和制造工艺缺陷导致产品出现故障而影响使用，属于产品无偿保修范围。生产材料缺陷是指产品生产过程中因组件配件质量或功能缺陷导致产品无法使用，包括万向轮、提手转轴、拉杆、海关锁、连接片、内里拉链质量和功能异常。制造工艺缺陷是指产品在生产过程中因技术参数失真或异常导致产品无法正常使用，包括螺丝松动、缝纫开线、内里脱胶、表面自然掉漆等。',
                                descriptionen:
                                    'ssssssssssssssssssssssssssssssss',
                               
                                },
                                {
                                title: '产品无偿保修范围:',
                                titleen: '产品无偿保修sss范围:',
                                description:
                                    '因暴力破解、暴力托运自行拆卸、故意碰撞、腐蚀破坏、超负荷承载、遗忘开箱密码无法开箱等非正常使用情形而导致产品质量下降或无法使用。',
                                descriptionen:
                                    'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
                                
                                },
                            ],
                    },
                tentsix:{
                    title:'保修服务流程',
                    titleen:'kkkkk',
                    contont:'谱祺官方售后客服(电话:020-3939 0239)',
                    contonten:'oooooo(电话:020-3939 0239,工作日拨打)',
                    imageUrlsix:require('../../assets/afteraction.png'),
                    imageUrlsixen:require('../../assets/afteraction.png'),
                }  ,
                fqa:{
                    title:'保修服务常见问题',
                    titlen:'kippss',
                    contentend:'本售后及保修服务适用于PUKI谱祺所有产品。',
                    contentenden:'暂无',
                    faqItems: [
                                    {
                                    question: "Q:保修服务产生的物流费用由谁来支付?",
                                    answer: "A: 无偿保修周期内,寄修过程中所产生的物流费用按照“谁寄谁付\"的原则各自承担;无偿保修周期外，寄修过程所产生的物流费用由发起申请的用户自行承担。",
                                    questionen: "sss?",
                                    answeren: "sddddddd,寄修过程中所产生的物流费用按照“谁寄谁付\"的原则各自承担;无偿保修周期外，寄修过程所产生的物流费用由发起申请的用户自行承担。",
                                    
                                },
                                    {
                                    question: "Q:发起保修服务申请需要提供什么凭证?",
                                    answer: "A: 发起保修申请时需要提供的凭证包括:产品序列号(位于产品外箱正面底部的 9位数字)、购买记录(订单号、购买时间等)、产品发票(电子或纸质发票均可)。",
                                    questionen: "sss?",
                                    answeren: "sddddddd,寄修过程中所产生的物流费用按照“谁寄谁付\"的原则各自承担;无偿保修周期外，寄修过程所产生的物流费用由发起申请的用户自行承担。",
                                        
                                },
                                    {
                                    question: "Q:除物流费用之外的保修费用如何核算?",
                                    answer: "A: 我们将严格按照官方发布的保修政策向用户提供保修评估方案。在收到用户的报修申请后,我们会在24 小时内向用户反馈保修性质、保修费用、时间进度等标准化评估信息。用户在确认保修评估方案后进入寄送流程。",
                                    questionen: "sss?",
                                    answeren: "sddddddd,寄修过程中所产生的物流费用按照“谁寄谁付\"的原则各自承担;无偿保修周期外，寄修过程所产生的物流费用由发起申请的用户自行承担。",
                                        
                                },
                                ],
                },

                imageUrlone: require('../../assets/pic-service.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                isScrolled: false,
        
            };
        },

        mounted() {
            this.fetchData();
            this.initObserver(); // 初始化观察器
             window.addEventListener('wheel', this.initObserver, { passive: false });
            // window.addEventListener('wheel', this.handleScroll, { passive: false });
            // this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

            // 上传成功回调 
                handleSuccess(response, file, fileList) { 
                    // console.log(response)
                    if (response.code  === 200) { // 假设服务器返回的成功码是 200 
                              // 拼接图片 URL，确保路径正确
                                const imageUrl = `${apiUrls.baseUrl}/website/images/`+ response.filePath;
                                
                                // 将上传的图片信息添加到 fileList 中
                                this.fileList.push({
                                name: file.name,
                                url: imageUrl
                                });

                    // 设置预览图片的 URL
                    this.dialogImageUrl = imageUrl;
                            this.dialogVisible = true; // 显示预览框
                           
                        } else { 
                            this.$message.error(' 上传失败'); 
                        } 
                },
            // 删除图片的回调
    handleRemove(file, fileList) {
      // 处理删除逻辑，删除 fileList 中的该图片
    //   console.log('删除图片:', file);
      
      // 根据上传时的 `uid` 删除对应图片
      const index = this.fileList.findIndex(item => item.uid === file.uid);
      if (index !== -1) {
        this.fileList.splice(index, 1); // 从 fileList 中删除该文件
      }

      this.$message.success('图片删除成功');
    },

            /**
                 * 验证表单输入
                 */
                 validateForm() {
                    const { name, phone, email, address, message } = this.fomeillustrate;

                    // 校验每个字段是否为空
                    if (!name || !phone || !email) {
                        return false;
                    }

                    // 根据需要添加其他字段的校验逻辑（例如正则验证邮箱格式）
                    return true;
                },
            /**
             * 提交表单
             */
            handleSubmit() {
                if (this.isSubmitting) {
                    // 如果正在提交，防止重复提交
                    return;
                }
                
                                // 验证表单输入
                    if (!this.validateForm()) {
                        this.$message.error('请填写完整的表单信息！');
                        return;
                    } 
                     // 设置提交状态为正在提交
                  this.isSubmitting = true;
                  // 将所有文件的 name 值提取出来并通过逗号连接
                  this.fomeillustrate.imagess = this.fileList.map(file => file.name).join(',');


                //   console.log('表单数据准备提交:', this.fomeillustrate);
               
                  // 使用 axios 发起 POST 请求将数据提交到后端
                    axios.post(`${apiUrls.baseUrl}/website/addaftersalesform`, this.fomeillustrate)
                        .then(response => {
                            this.$message({
                                message: response.data || '已提交！',
                                type: 'success',
                                duration: 2000
                            });

                            // 提交成功后清空表单
                            this.fomeillustrate = {
                                name: '',
                                phone: '',
                                email: '',
                                address: '',
                                message: '',
                                imagess:''
                            };
                            this.fileList=[];

                             // 提交成功后清空表单
                              this.resetForm();

                            // 3秒后恢复提交按钮可点击状态   
                            setTimeout(() => {
                                this.isSubmitting = false;
                            }, 3000);
                        })
                        .catch(error => {
                            const errorMessage = error.response.data.message;
                            this.$message.error(errorMessage);
                            this.isSubmitting = false;
                        });                
            },
          



            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/aftersales`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                    // 分批赋值
                    this.throttledAssignData(data);
                 
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        }, 
        /**
         * 
         * @param html 文本提取
         */
        stripHTMLTags(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 获取文档体的纯文本内容
        return doc.body.textContent || '';
    },
    /**
     * 
     * @param html li文本提取
     */
    stripHTMLTags2(html) {
        // 创建一个 DOMParser 实例
        const parser = new DOMParser();
        // 将 HTML 字符串解析成文档对象
        const doc = parser.parseFromString(html, 'text/html');
        // 提取所有 <li> 元素的文本内容，并存入数组
            return Array.from(doc.querySelectorAll('li')).map(item => item.textContent.trim());
    },
            /**
             * 
             * @param html 重要说明的数据提取
             */
            extractTextByTag(html) {
            // 创建一个 DOMParser 实例
            const parser = new DOMParser();
            // 将 HTML 字符串解析为文档对象
            const doc = parser.parseFromString(html, 'text/html');
            
            // 定义一个对象，用于按标签类型存储文本
            const groupedText = {};

            // 遍历文档中的所有子元素
            Array.from(doc.body.children).forEach(node => {
                const tagName = node.tagName.toLowerCase(); // 获取标签名
                const textContent = node.textContent.trim(); // 获取纯文本并去除空白

                if (textContent) {
                    // 如果对应标签的数组不存在，则初始化
                    if (!groupedText[tagName]) {
                        groupedText[tagName] = [];
                    }
                    // 将文本加入对应标签的数组
                    groupedText[tagName].push(textContent);
                }
            });

            return groupedText;
        },
         throttledAssignData(data) {
            // 定义赋值的节奏
            const steps = [
                () => {
                    this.tenttwo.imageUrltwo = `${apiUrls.devApi}${data[0].imageUrltwo}`;
                    this.tenttwo.texttwo=data[0].tenttwotexttwo;
                    this.tenttwo.texttwoen=data[0].tenttwotexttwoen;
                    this.tentthree.titleone=data[0].tentthreetitleone;
                    this.tentthree.titleoneen=data[0].tentthreetitleoneen;
                    // 提取 tentthreecontent 中的文本内容
                  this.tentthree.content = this.stripHTMLTags(data[0].tentthreecontent);
                  this.tentthree.contenten = this.stripHTMLTags(data[0].tentthreecontenten);
                  this.tenttfour.titleone=data[0].tenttfourtitleone;
                  this.tenttfour.titleoneen=data[0].tenttfourtitleoneen;
                  // 提取 tenttfourcontent 中的纯文本内容
                    this.tenttfour.content = this.stripHTMLTags2(data[0].tenttfourcontent);
                     // 提取 tenttfourcontent 中的纯文本内容
                     this.tenttfour.contenten = this.stripHTMLTags2(data[0].tenttfourcontenten);
                     this.tenttfour.remarker = data[0].remarker;
                     this.tenttfour.remarkeren = data[0].remarkeren;


                },
                () => {
                   
                  
                                    // 将返回的路径字符串分割为数组
                const imagePaths = data[0].servicesimgSrc.split(','); // 将路径字符串分割为数组
                const servicestitle= data[0].servicestitle.split(';'); // 将路径字符串分割为数组
                const servicestitleen= data[0].servicestitleen.split(';'); // 将路径字符串分割为数组
                const description=this.stripHTMLTags(data[0].servicesdescription).match(/[^。]+。/g) || [];
                const descriptionen=this.stripHTMLTags(data[0].servicesdescriptionen).match(/[^。]+。/g) || [];
                
                
                  // 遍历 imagePaths 动态创建 services，同时记录下标
                    this.services = imagePaths.map((path, index) => {
                        return {
                            imgSrc: `${apiUrls.devApi}${path}`, // 拼接完整路径
                             title:servicestitle[index],
                             titleen:servicestitleen[index],
                             description:description[index],
                             descriptionen:descriptionen[index],
                        };
                    });
                },
                () => {
                    this.zhoangyaoshuoming.title= data[0].zhoangyaoshuomingtitle;
                    this.zhoangyaoshuoming.titleen= data[0].zhoangyaoshuomingtitleen;
                    //重要说明的中文描述
                    const ss =this.extractTextByTag(data[0].zhoangyaoshuomingitemsdescription)
                    //重要说明的英文描述
                    const ssen =this.extractTextByTag(data[0].zhoangyaoshuomingitemsdescriptionen)
                    // 性能优化赋值
                   // 覆盖赋值 this.zhoangyaoshuoming.items
                    this.zhoangyaoshuoming.items = ss.ol.map((title, index) => {
                        console.log(title)
                        return {
                            title: title,
                            description: ss.p[index] || '',         // 如果 `p` 数组缺少内容，设置为空字符串
                            titleen: ssen.ol[index] || '',          // 同步 ssen 的内容
                            descriptionen: ssen.p[index] || ''      // 同步 ssen 的描述
                        };
                    });
                    // console.log(this.zhoangyaoshuoming.items)
                },
                () => {
                    //保修服务流程
                    this.tentsix.title=data[0].tentsixtitle;
                    this.tentsix.titleen=data[0].tentsixtitleen;
                    this.tentsix.contont=data[0].tentsixcontont;
                    this.tentsix.contonten=data[0].tentsixcontonten;
                    // this.tentsix.imageUrlsix=`${apiUrls.devApi}${data[0].tentsiximageUrlsix}`;
                    const fileArray = data[0].tentsiximageUrlsix.split(','); 
                    this.tentsix.imageUrlsix=`${apiUrls.devApi}${fileArray[0]}`;
                    this.tentsix.imageUrlsixen=`${apiUrls.devApi}${fileArray[1]}`;

                    //FQA
                    this.fqa.title=data[0].fqatitle;
                    this.fqa.titlen=data[0].fqatitleen;
                    this.fqa.contentend=data[0].fqacontentend;
                    this.fqa.contentenden=data[0].fqacontentenden;

                    //fqa问答
                    const content2 = this.stripHTMLTags(data[0].faqItemsquestion);
                    const content3 = this.stripHTMLTags(data[0].faqItemsquestionen);
                                    // 用正则表达式提取所有Q:和A:之间的内容
                    const questionPattern = /Q:([^A]+?)A:/g;  // 匹配 Q: 到 A: 之间的内容（问题）
                    const answerPattern = /A:([^Q]+)/g;      // 匹配 A: 到 Q: 之间的内容（答案）

                    const questions = [];
                    const answers = [];
                    const questionsEn = [];
                    const answersEn = [];
                     // 提取所有问题
                    let match;
                    while (match = questionPattern.exec(content2)) {
                        questions.push(match[1].trim());  // 将问题内容去掉多余的空格，保存到数组
                    }

                    // 提取所有答案
                    while (match = answerPattern.exec(content2)) {
                        answers.push(match[1].trim());  // 将答案内容去掉多余的空格，保存到数组
                    }
                    // 提取英文问题和答案
                    while (match = questionPattern.exec(content3)) {
                        questionsEn.push(match[1].trim());  // 将问题内容去掉多余的空格，保存到数组
                    }
                    while (match = answerPattern.exec(content3)) {
                        answersEn.push(match[1].trim());  // 将答案内容去掉多余的空格，保存到数组
                    }

                   // 确保问题和答案的数量相等
                    const maxLength = Math.min(questions.length, answers.length, questionsEn.length, answersEn.length);

                     
                      // 组装faqItems数组
                    const faqItems = [];
                    for (let i = 0; i < maxLength; i++) {
                        faqItems.push({
                            question: `Q: ${questions[i]}`,
                            answer: `A: ${answers[i]}`,
                            questionen: `Q: ${questionsEn[i]}`, // 英文问题
                             answeren: `A: ${answersEn[i]}`    // 英文答案
                        });
                    }
                     // 将最终的faqItems数组赋值给this.faqItems
                     this.fqa.faqItems = faqItems;
                    // console.log(faqItems)


                 
                }
            ];

            let stepIndex = 0;

            const assignNextStep = () => {
                if (stepIndex < steps.length) {
                    steps[stepIndex](); // 执行当前赋值步骤
                    stepIndex++;

                    // 使用 setTimeout 控制下一次赋值节奏
                    setTimeout(assignNextStep, 100); // 每次间隔 100ms
                } else {
                    console.log('所有数据赋值完成');
                }
            };

            assignNextStep(); // 开始逐步赋值
        },
            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
/*? -------------------------------------------*/
 /* 按钮样式 */
 .submit-btn {
    width: 6vw;
    padding: 1.5vh;
    background-color: #333;
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-left: 12.2vw;
    
}
.submit-btn:hover {
    background-color: #555;
}

.fomeillustrate{
display: flex;
flex-direction: column;      /* 子元素垂直排列 */
justify-content: center;     /* 垂直方向居中 */
align-items: center;         /* 水平方向居中 */
margin-top: -3vh;
/* height: 40vh; */
margin-bottom: 8vh;

}
.fomeillustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 5vh;
}

/* 表单容器样式 */
.form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 100vh; */
    background-color: white;

}

.form-container .custom-form{
  width: 60vw;
  /* background-color: white; */
  border-radius: 5px;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}
.form-container .custom-form .form-group {
    margin-bottom: 6vh;
    display: flex;
    align-items: center;
    gap: 3vw;
    
}
.form-container .custom-form .form-group label {
    width: 9vw; /* 标签宽度，保持对齐 */
    font-size: 1rem;
    color: #333;
    text-align: left;
    
}
.form-container .custom-form .form-group input, textarea {
    flex: 1;
    padding: 1vw;
    border: 1px solid #ddd;
    /* border-radius: 3px; */
    background-color: #f5f5f5;
    font-size: 14px;
    color: #333;
    outline: none;
    transition: border-color 0.3s;

}

textarea {
    resize: none; /* 禁止调整大小 */
    height: 10vh;
}


.illustrate{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    margin-top: 5vh;
    height: 45vh;
}
.illustrate .title{
width: 60vw;
font-weight: bold;
font-size: 1.5rem;
margin-bottom: 3vh;
}
.illustrate .contentphone{
width: 60vw;
font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;
}
.illustrate .contentemail{
width: 60vw;
font-size:1rem;
line-height: 2;
color: gray;
white-space: pre;

}
/*? -------------------------------------------*/








/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
